import {createReducer} from "redux-act";
import * as actions from "modules/actions";
import PersistStorage from "modules/utils/PersistStorage";

export interface IUser {
	id: number;
	email: string;
	username: string;
	isNotificationsEnabled: boolean;
	lang: string;
	supportedCountry: string;
}

export interface IUserReducer {
	is_authenticated: boolean;
	is_preregistered: boolean;
	user: IUser;
}

const defaultState = {
	is_authenticated: Boolean(PersistStorage.GET("is_authenticated")),
	is_preregistered: Boolean(PersistStorage.GET("is_preregistration")),
	user: {
		id: 0,
		email: "",
		username: "",
		isNotificationsEnabled: false,
		lang: "",
		supportedCountry: PersistStorage.GET("userSupportedCountry") || "",
	},
};

export const user = createReducer<IUserReducer>({}, defaultState)
	.on(actions.userLogin, (state: IUserReducer) => ({
		...state,
	}))
	.on(actions.userBackdoorLoginSuccess, (state: IUserReducer, payload: IUser) => ({
		...state,
		is_authenticated: true,
		user: payload,
	}))
	.on(actions.updateUser, (state, payload) => {
		PersistStorage.SET("userSupportedCountry", payload.supportedCountry);

		return {
			...state,
			user: payload,
		};
	})
	.on(actions.userPreregistrationSuccess, (state) => {
		return {
			...state,
			is_preregistered: true,
		};
	});
